export default {
  alternativeDomain: {
    label: 'Domínio alternativo',
    unknownDomain: 'Domínio desconhecido'
  },
  multiLanguage: {
    label: 'Multi-idiomas',
    installedMessage:
      'Instalado|Instalado - {count} idioma|Instalado - {count} idiomas',
    addLanguage: 'Adicionar idioma'
  },
  planInfo: {
    name: 'Plano: {name}',
    additionalSite: 'Site Adicional',
    includedDomain: 'Site da hospedagem: {includedDomain}'
  },
  manageButton: 'Administrar'
}
